export default [
  'User',
  'Parent',
  'Reseller',
  'Admin',
]
